export default __webpack_public_path__ + "static/media/chem-supply-chain.5bbcf0e0.png";